import * as React from "react";
import * as ReactDOM from "react-dom";
import { MarketingEmailOptions, PatientInformation } from "../commons/model/patient/PatientInfo";
import ToggleButton from "../commons/components/buttons/ToggleButton";
import ModalConfirm from "../commons/components/modal/ModalConfirm";
import { useState } from "react";
import "./MarketingEmailModal.scss"
import sfetch from "../commons/utils/super-fetch";

interface TagModalProps {
  closeModal: () => void;
  patient?: PatientInformation;
  marketingEmailOptions: MarketingEmailOptions;
}

export default function MarketingEmailModal({
  closeModal,
  patient,
  marketingEmailOptions
}: TagModalProps) {
  const [acceptEmailOption, setAcceptEmailOption] = useState(marketingEmailOptions?.acceptMarketingEmail);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const saveOption = () => {
    setErrorMessage(undefined)
    if (acceptEmailOption != marketingEmailOptions?.acceptMarketingEmail) {
      return sfetch(`${marketingEmailOptions.updateConsentPath}?marketingEmailConsent=${acceptEmailOption}`, {
        method: "PATCH",
      })
      .then(() => {
        marketingEmailOptions.acceptMarketingEmail = acceptEmailOption
        closeModal();
      })
      .catch(() => setErrorMessage(i18n["Global.TechnicalError"]));
    } else {
      setSaveDisabled(true)
    }
  }
  const onToggleEditChange = (newValue) => {
    setAcceptEmailOption(newValue);
    if (newValue != marketingEmailOptions?.acceptMarketingEmail) {
      setSaveDisabled(false)
    } else {
      setSaveDisabled(true)
    }
  }

  const title = `${i18n["Page.PatientManagement.About.EditModal.Title"]} ${patient.fullName}`

  return (
    <ModalConfirm
      title={title}
      cancel={closeModal}
      action={saveOption}
      actionButtonLabel={i18n["Page.PatientManagement.About.EditModal.ActionButton"]}
      dialogClass="max-width"
      actionDisabled={saveDisabled}
    >
      <div className="modal-container">
        {errorMessage && (
          <div className="message danger">{errorMessage}</div>
        )}
        <div className="toggle">
          <span className="span-text margin-right">{i18n["Page.PatientManagement.About.EditModal.ToggleText"]}</span>
          <ToggleButton
            value={acceptEmailOption}
            onChange={onToggleEditChange}
            label=" "
          />
        </div>
        <span className="span-text">{i18n["Page.PatientManagement.About.EditModal.InfoText"]}</span>
      </div>
    </ModalConfirm>
  );
}

MarketingEmailModal.loadComponent = (elementId, props) =>
  ReactDOM.render(<MarketingEmailModal {...props} />, document.getElementById(elementId));
